import { makeStyles } from '@material-ui/core/styles'

export const useDialogTitleStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 12,
    overflow: 'hidden',
  },
  titleRoot: {
    position: 'relative',
    padding: theme.spacing(3, 7, 1, 3),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    color: '#172024',
  },
  content: {
    padding: theme.spacing(1, 3, 3),
  },
  bodyText: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}))
